import script from "./svc-stlm-mn-chng.vue?vue&type=script&setup=true&lang=js"
export * from "./svc-stlm-mn-chng.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__